import {
  CROSS_SELL_PDP_CENTER_SLIDER,
  CROSS_SELL_PDP_OUT_OF_STOCK_CENTER_SLIDER,
  CROSS_SELL_PDP_RX_CENTER_SLIDER,
  type CrossSellWidgetType,
} from '../../../cross-sell'

export const productAccessorAvailableProductWidgetType = ({
  isAvailable,
  isRx,
}: {
  isAvailable: boolean
  isRx: boolean
}): CrossSellWidgetType => {
  if (isRx) {
    return CROSS_SELL_PDP_RX_CENTER_SLIDER
  }

  if (!isAvailable) {
    return CROSS_SELL_PDP_OUT_OF_STOCK_CENTER_SLIDER
  }

  return CROSS_SELL_PDP_CENTER_SLIDER
}
